/**
 * Created by razial on 13.03.2026.
 */

const EditorMap2dReference = function (bundleId, data) {
    cleverapps.EventEmitter.call(this);

    this.bundleId = bundleId;

    this.imageVisible = false;
    this.imageEditable = false;

    this.x = data && data.x || 0;
    this.y = data && data.y || 0;

    this.opacity = 125;
    this.scale = data && data.scale || 1;
    this.rotation = data && data.rotation || 0;
    this.skewX = data && data.skewX || 0;
    this.skewY = data && data.skewY || 0;
};

EditorMap2dReference.prototype = Object.create(cleverapps.EventEmitter.prototype);
EditorMap2dReference.prototype.constructor = EditorMap2dReference;

EditorMap2dReference.prototype.isAvailable = function () {
    return Boolean(bundles[this.bundleId] && bundles[this.bundleId].urls.sample_img);
};

EditorMap2dReference.prototype.setImageVisible = function (visible) {
    this.imageVisible = visible;
    this.trigger("imageVisibilityChanged");
};

EditorMap2dReference.prototype.isImageVisible = function () {
    return Boolean(this.imageVisible);
};

EditorMap2dReference.prototype.setImageEditable = function (editable) {
    this.imageEditable = editable;
    this.trigger("imageEditableChanged");

    if (editable && !this.imageVisible) {
        this.setImageVisible(true);
    }
};

EditorMap2dReference.prototype.isImageEditable = function () {
    return Boolean(this.imageEditable);
};

EditorMap2dReference.prototype.setImageOpacity = function (opacity) {
    this.opacity = opacity;
    this.trigger("imageOpacityChanged");
};

EditorMap2dReference.prototype.getImageOpacity = function () {
    return this.opacity;
};

EditorMap2dReference.prototype.setImagePosition = function (x, y) {
    this.x = x;
    this.y = y;
    this.trigger("imagePositionChanged");
    this.trigger("save");
};

EditorMap2dReference.prototype.getImagePosition = function () {
    return cc.p(this.x, this.y);
};

EditorMap2dReference.prototype.setImageScale = function (scale) {
    this.scale = scale;
    this.trigger("imageScaleChanged");
    this.trigger("save");
};

EditorMap2dReference.prototype.getImageScale = function () {
    return this.scale;
};

EditorMap2dReference.prototype.setImageRotation = function (rotation) {
    this.rotation = rotation;
    this.trigger("imageRotationChanged");
    this.trigger("save");
};

EditorMap2dReference.prototype.getImageRotation = function () {
    return this.rotation;
};

EditorMap2dReference.prototype.setImageSkew = function (skewX, skewY) {
    this.skewX = skewX;
    this.skewY = skewY;
    this.trigger("imageSkewChanged");
    this.trigger("save");
};

EditorMap2dReference.prototype.getImageSkew = function () {
    return { x: this.skewX, y: this.skewY };
};

EditorMap2dReference.prototype.getSaveInfo = function () {
    if (!this.isAvailable()) {
        return undefined;
    }

    const info = {};

    if (this.x) {
        info.x = this.x;
    }
    if (this.y) {
        info.y = this.y;
    }
    if (this.scale !== 1) {
        info.scale = this.scale;
    }
    if (this.rotation) {
        info.rotation = this.rotation;
    }
    if (this.skewX) {
        info.skewX = this.skewX;
    }
    if (this.skewY) {
        info.skewY = this.skewY;
    }

    return Object.keys(info).length > 0 ? info : undefined;
};

EditorMap2dReference.prototype.getImage = function () {
    return bundles[this.bundleId].urls.sample_img;
};